<template>
  <router-view />
</template>

<style lang="scss">
/** Inject app styles*/
@use "assets/style.scss";
</style>
